import { HorizontalSafeAreaContainer } from '../../../components';
import { ReorderModal } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <ReorderModal />
    </HorizontalSafeAreaContainer>
  );
}
